import React, { useEffect, useState } from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Pagetitle from "../elements/Pagetitle";
import emailjs from '@emailjs/browser';

function Contact() {
  const [formdata, setFormdata] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const submitHandler = async (event) => {
    event.preventDefault();
    if (!formdata.name) {
      setError(true);
      setMessage("Please enter your name");
    } else if (!formdata.email) {
      setError(true);
      setMessage("Please enter your email address");
    } else if (!formdata.subject) {
      setError(true);
      setMessage("Please enter a subject");
    } else if (!formdata.message) {
      setError(true);
      setMessage("Please enter your message");
    } else {
      setError(false);
      setMessage("Sending message...");

      try {
        await emailjs.send(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          {
            from_name: formdata.name,
            from_email: formdata.email,
            subject: formdata.subject,
            message: formdata.message,
          },
          process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        );
        setMessage("Message sent successfully! I'll get back to you soon.");
        // Clear the form
        setFormdata({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      } catch (error) {
        setError(true);
        setMessage("Failed to send message. Please try again or contact me directly.");
        console.error('EmailJS error:', error);
      }
    }
  };

  const handleChange = (event) => {
    setFormdata({
      ...formdata,
      [event.currentTarget.name]: event.currentTarget.value,
    });
  };

  const handleAlerts = () => {
    if (error && message) {
      return <div className="alert alert-danger mt-4">{message}</div>;
    } else if (!error && message) {
      return <div className="alert alert-success mt-4">{message}</div>;
    } else {
      return null;
    }
  };

  return (
    <section id="contact">
      <div className="container">
        <Pagetitle title="Let's Connect" />

        <div className="row">
          <div className="col-md-4">
            <div className="contact-info">
              <AnimationOnScroll
                animateIn="animate__fadeInUp"
                animateOut="animate__fadeOutDown"
                animateOnce={true}
              >
                <h3>Ready to Start a Project?</h3>
              </AnimationOnScroll>
              <AnimationOnScroll
                animateIn="animate__fadeInUp"
                animateOut="animate__fadeOutDown"
                animateOnce={true}
              >
                <p>
                  I'm available for freelance projects, consulting, and part-time/full-time opportunities in Canada or Elsewhere. Let's discuss how I can help bring your ideas to life.
                </p>
                <p className="mt-4">
                  <strong>Prefer email?</strong> Reach me at{" "}
                  <a href="mailto:sayotagt@gmail.com">sayotagt@gmail.com</a>
                </p>
                <p className="mt-3">
                  <strong>Response time:</strong> Usually within 24 hours
                </p>
              </AnimationOnScroll>
            </div>
          </div>

          <div className="col-md-8">
            <form
              id="contact-form"
              className="contact-form mt-6"
              onSubmit={submitHandler}
            >
              <div className="row">
                <div className="column col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      id="InputName"
                      placeholder="Your Name *"
                      onChange={handleChange}
                      value={formdata.name}
                      required
                    />
                  </div>
                </div>

                <div className="column col-md-6">
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      id="InputEmail"
                      name="email"
                      placeholder="Your Email *"
                      onChange={handleChange}
                      value={formdata.email}
                      required
                    />
                  </div>
                </div>

                <div className="column col-md-12">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="InputSubject"
                      name="subject"
                      placeholder="Subject *"
                      onChange={handleChange}
                      value={formdata.subject}
                      required
                    />
                  </div>
                </div>

                <div className="column col-md-12">
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="InputMessage"
                      className="form-control"
                      rows="5"
                      placeholder="Tell me about your project... *"
                      onChange={handleChange}
                      value={formdata.message}
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                name="submit"
                id="submit"
                value="Submit"
                className="btn btn-default btn-lg"
              >
                <i className="icon-paper-plane"></i> Send Message
              </button>
            </form>
            {handleAlerts()}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
